import React from "react"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import {
  Wrapper,
  WrapperRed,
  WrapperWhite,
  Inner,
  Row,
  Col6,
  Col12,
  LabelLight,
  LabelRight,
  LabelDark,
  LabelDarkRight,
  HandleImageWidthLarge,
  HandleImageWidthXLarge,
  Heading3,
  Heading1Red,
} from "../../styles/styles"

const Section2 = ({ data }) => (
  <>
    <Wrapper>
      <Row>
        <Col12>
          <Row>
            <Col6><LabelLight>APPLICATION</LabelLight></Col6>
            <Col6><LabelRight>LAUNCHING SOON</LabelRight></Col6>
          </Row>
          <Inner>
            <HandleImageWidthLarge>
              <Img
                fluid={data.laptopDark.childImageSharp.fluid}
              />
            </HandleImageWidthLarge>
          </Inner>
        </Col12>
      </Row>
    </Wrapper>
    <WrapperRed>
      <Row>
        <Col12>
          <Row>
            <Col6><LabelLight>APPLICATION</LabelLight></Col6>
            <Col6><LabelRight>APPAREL</LabelRight></Col6>
          </Row>
          <Inner>
            <HandleImageWidthLarge>
              <Img
                fluid={data.nikeKicks.childImageSharp.fluid}
              />
            </HandleImageWidthLarge>
          </Inner>
        </Col12>
      </Row>
    </WrapperRed>
    <Wrapper>
      <Row>
        <Col12>
          <Row>
            <Col6><LabelLight>APPLICATION</LabelLight></Col6>
            <Col6><LabelRight>APP ICONS</LabelRight></Col6>
          </Row>
          <Inner>
            <HandleImageWidthLarge>
              <Img
                fluid={data.appIcons.childImageSharp.fluid}
              />
            </HandleImageWidthLarge>
          </Inner>
        </Col12>
      </Row>
    </Wrapper>
    <Wrapper>
      <Row>
        <Col12>
          <Row>
            <Col6><LabelLight>APPLICATION</LabelLight></Col6>
            <Col6><LabelRight>APPAREL</LabelRight></Col6>
          </Row>
          <Inner>
            <HandleImageWidthXLarge>
              <Img
                fluid={data.sweats.childImageSharp.fluid}
              />
            </HandleImageWidthXLarge>
          </Inner>
        </Col12>
      </Row>
    </Wrapper>
    <Wrapper>
      <Row>
        <Col12>
          <Row>
            <Col6><LabelLight>APPLICATION</LabelLight></Col6>
            <Col6><LabelRight>TYPOGRAPHY</LabelRight></Col6>
          </Row>
          <Inner>
            <HandleImageWidthXLarge>
              <Img
                fluid={data.typography.childImageSharp.fluid}
              />
            </HandleImageWidthXLarge>
          </Inner>
        </Col12>
      </Row>
    </Wrapper>
    <WrapperWhite>
      <Row>
        <Col12>
          <Row>
            <Col6><LabelDark>APPLICATION</LabelDark></Col6>
            <Col6><LabelDarkRight>COLOR</LabelDarkRight></Col6>
          </Row>
          <Inner>
            <HandleImageWidthXLarge>
              <Img
                fluid={data.color.childImageSharp.fluid}
              />
            </HandleImageWidthXLarge>
          </Inner>
        </Col12>
      </Row>
    </WrapperWhite>
    <Wrapper>
      <Row>
        <Col12>
          <Inner>
            <Heading3>Round 2.</Heading3>
            <Heading1Red>END</Heading1Red>
          </Inner>
        </Col12>
      </Row>
    </Wrapper>
  </>
)

export default props => (
  <StaticQuery
    query={graphql`
      query {
        laptopDark: file(relativePath: { eq: "LaptopDark@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        nikeKicks: file(relativePath: { eq: "NikeKicks@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        appIcons: file(relativePath: { eq: "AppIcons@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        sweats: file(relativePath: { eq: "Sweats@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        typography: file(relativePath: { eq: "Typography@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        color: file(relativePath: { eq: "Colors@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => <Section2 data={data} {...props} />}
  />
)
